import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * @param {{ className?: string, dataTestId?: string } & React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>} props
 */
function RadioGroup({ className, dataTestId, ...props }) {
  return (
    <RadioGroupPrimitive.Root
      data-testid={dataTestId}
      className={cn('grid gap-2', className)}
      {...props}
    />
  );
}

/**
 * @param {{ className?: string, dataTestId?: string } & React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>} props
 */
function RadioGroupItem({ className, dataTestId, ...props }) {
  return (
    <RadioGroupPrimitive.Item
      data-testid={dataTestId}
      className={cn(
        // Checked state is --brand, the app's primary colour, matching Checkbox and the primary
        // button. Token-backed so it follows light/dark without branching on the mode.
        'aspect-square h-4 w-4 rounded-full border border-line-input text-brand shadow-sm disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-brand data-[state=checked]:bg-brand',
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle className="h-2 w-2 fill-white text-white" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
